import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { ZIndexLevels } from "../risk/geoUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/sharp-duotone-light-svg-icons";
import { PRETTY_BLUE } from "../trips/form/BorderWithLabel";

interface UserProfileIconProps
{
    onClick: () => void;
}

/**
 * UserProfileIcon component.
 *
 * @param {UserProfileIconProps} props - The component props.
 * @returns {JSX.Element} The rendered component.
 */
const UserProfileIcon: React.FC<UserProfileIconProps> = ( { onClick } ) =>
{
    const backgroundColor = PRETTY_BLUE;
    const [ isHovered, setIsHovered ] = useState( false );
    const backgroundColorHovered = "#e0e0e0";
    const boxShadow = "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)";
    return (
        <IconButton
            sx = {{ position: "absolute",
                top: "22px",
                right: "25px",
                height: "28px",
                width: "28px",
                borderRadius: "28px",
                backgroundColor: backgroundColor,
                color: "black",
                boxShadow: boxShadow,
                transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,opacity 0.8s",
                "&:hover": {
                    backgroundColor: backgroundColorHovered,
                    boxShadow: boxShadow,
                },
                zIndex: ZIndexLevels.BeneathDrawerUiElement }}
            onClick = {onClick}
            onMouseOver = {() => setIsHovered( true )}
            onMouseLeave = {() => setIsHovered( false )}
            color = "inherit"
        >
            <FontAwesomeIcon icon = {faGear} size = "xs" color = {isHovered ? "black" : "white"} fixedWidth/>
        </IconButton>
    );
};

export default UserProfileIcon;
